import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const initHorizontalScroll = () => {
	const scrollers = document.querySelectorAll('.horizontal-scroll');

	scrollers.forEach((scroller) => {
		const pinTarget = scroller.dataset.pin
				? document.querySelector(scroller.dataset.pin)
				: scroller.parentElement;

		if (!pinTarget) return;

		const scrollWidth = scroller.scrollWidth;
		const scrollLength = scrollWidth - window.innerWidth;

		// Store original classes to transfer to pin-spacer
		const pinClasses = [ ...pinTarget.classList ];

		gsap.to(scroller, {
			x: -scrollLength,
			ease: 'none',
			scrollTrigger: {
				trigger: pinTarget,
				pin: true,
				scrub: true,
				start: 'top top',
				end: () => `+=${scrollWidth}`,
				invalidateOnRefresh: true,
				// markers: true,
				onRefresh: (self) => {

				},
			},
		});
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initHorizontalScroll);
} else {
	initHorizontalScroll();
}

export default initHorizontalScroll;
